
import React from 'react';
import SearchResultPageClient from './SearchResultPageClient';
import SearchResultProvider from './context/SearchResultContext';

const SearchResultPage = (props) => {

    return (
        <>
            <SearchResultProvider>
                <SearchResultPageClient {...props} />
            </SearchResultProvider>
        </>
    );
};

export default SearchResultPage;
